import { restakingVaultState } from "@/atoms/restakingState"
import { refreshCounterRestakingAtom } from "@/atoms/settings"
import { allTokenInfosAtom } from "@/atoms/tokenInfos"
import { RestakingVaultState } from "@/utils/dataTypes"
import { Box } from "@mui/material"
import { PublicKey } from "@solana/web3.js"
import { useAtomValue, useSetAtom } from "jotai"
import { useEffect } from "react"
import { useQuery } from "react-query"
import { DevelopingModal } from "../commonModals/developingModal"
import { StakingDetail } from "./components/detail"
import { ClaimStakingModal } from "./components/modal/claimStakingModal"
import { StopUnstakingModal } from "./components/modal/stopUnstakingModal"
import { StakingOverview } from "./components/overview"
import useRestaking from "@/hooks/useRestaking"
import * as styles from "./styles"

const View = () => {
  const { fetchVaultFn } = useRestaking()
  const setRestakingVault = useSetAtom(restakingVaultState)
  const allTokenInfos = useAtomValue(allTokenInfosAtom)
  const refreshStakingCounter = useAtomValue(refreshCounterRestakingAtom)
  const { data: dataRestakingVault } = useQuery(["fetchVaultFn", refreshStakingCounter], () => fetchVaultFn(), {
    refetchOnWindowFocus: false,
    refetchInterval: 5000,
  })

  useEffect(() => {
    if (dataRestakingVault && dataRestakingVault.isSucceeded && "result" in dataRestakingVault && allTokenInfos) {
      const lockDurations = (dataRestakingVault.result.lockupOptions as any).map((lockupOption: any) => ({
        duration: lockupOption.duration.toNumber(),
        minUnstakingAmount: lockupOption.minUnstakingAmount.toNumber(),
      }))
      const rewards = (dataRestakingVault.result.rewards as any).map((reward: any) => {
        const rewardInfo = allTokenInfos.find((info) => info.address === reward.rewardTokenMint)
        return {
          rewardTokenDecimals: reward.rewardTokenDecimals,
          rewardTokenMint: new PublicKey(reward.rewardTokenMint),
          timestamp: reward.timestamp.toNumber(),
          logo: rewardInfo?.logoURI,
          symbol: rewardInfo?.symbol,
          name: rewardInfo?.name,
        }
      })
      const vaultStat = {
        emissionPerDay: dataRestakingVault.result.currentStat.emissionPerDay.toNumber(),
        totalStakedAmount: dataRestakingVault.result.currentStat.totalStakedAmount.toNumber(),
        totalStakers: dataRestakingVault.result.currentStat.totalStakers.toNumber(),
      }
      const dataToSet: RestakingVaultState = {
        vaultOwner: new PublicKey(dataRestakingVault.result.vaultOwner),
        vaultTokenAccount: new PublicKey(dataRestakingVault.result.vaultTokenAccount),
        allowedToken: new PublicKey(dataRestakingVault.result.allowedToken),
        lockupOptions: lockDurations,
        rewards,
        vaultStat,
      }
      setRestakingVault(dataToSet)
    }
  }, [allTokenInfos, dataRestakingVault, setRestakingVault])

  return (
    <Box sx={styles.homeWrapper}>
      <StakingOverview />
      <StakingDetail />

      <ClaimStakingModal />
      <StopUnstakingModal />
      <DevelopingModal />
    </Box>
  )
}

export default View
